export default __webpack_public_path__ + "static/1463-db131241d8dfaa5b12ce697b19c83545.gif";